import { render, staticRenderFns } from "./UsageFeesOnlyPaymentRateTable.vue?vue&type=template&id=ac922de6&scoped=true&lang=pug"
import script from "./UsageFeesOnlyPaymentRateTable.vue?vue&type=script&lang=ts"
export * from "./UsageFeesOnlyPaymentRateTable.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesOnlyPaymentRateTable.vue?vue&type=style&index=0&id=ac922de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac922de6",
  null
  
)

export default component.exports